import React, { memo, useEffect } from 'react';
import { RendererClient } from '../internal';
import { fillParentStyles } from './util';

export type EventPreviewOverlayProps = {
  rendererClient: RendererClient;
};

export const EventPreviewOverlay: React.FC<EventPreviewOverlayProps> = memo(
  function EventPreviewOverlay({ rendererClient }) {
    // Present the event preview in playback mode. This gives the user a
    // full-fidelity preview of the event, but they can't interact with it.
    useEffect(() => {
      rendererClient.setMode({ mode: 'playback' });
    }, [rendererClient]);

    return (
      <div
        data-testid="event-preview-overlay"
        role="none"
        tabIndex={-1}
        style={{
          ...fillParentStyles,
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
    );
  },
);
